import React, { useState } from 'react'
import { Select, Button, Drawer } from 'antd';
import TractorCardSmall from './TractorCardSmall'
import tractor1 from '../../images/tractor-1.jpg'
import tractor2 from '../../images/tractor-2.jpg'
import tractor3 from '../../images/tractor-3.png'
import TractorFilter from '../Filter/TractorFilter'
import { FilterFilled } from '@ant-design/icons';


const { Option } = Select;


function TractorListings() {
    // const [sortType, setSortType] = useState('')
    const [openFilter, setOpenFilter] = useState(false)
    const onSortTypeChange = (value) => console.log(value)

    const showFilter = () => setOpenFilter(true)  
    const onFilterClose = () => setOpenFilter(false)

    return (
            <div className="">
                <div className="md:flex md:items-center md:justify-between">
                    <div className="md:px-3 mb-3 md:flex md:items-baseline">
                        <p className="text-xl font-bold tracking-wide mr-1">Upcoming Tractors</p>
                        <span className="text-sm text-gray-500">(Showing 1-14 from 128 products)</span>
                    </div>
                    <div className="md:px-3 mb-3 flex justify-between">
                        <div>
                            <Select
                                className="w-48"
                                placeholder="Sort products by"
                                // onChange={setSortType}
                                optionLabelProp="label"
                                onSelect={onSortTypeChange}
                                // showSearch=
                                showArrow
                                >
                                    <Option value="priceLH" label={"Price - Low to High"} key={1}>
                                        Price - Low to High
                                    </Option>
                                    <Option value="priceHL" label={"Price - High to Low"} key={1}>
                                        Price - High to Low
                                    </Option>
                                    {/* <Option value="priceLH" label={"Price - Low to High"} key={1}>
                                        Popularity
                                    </Option> */}
                            </Select>
                        </div>
                        <div className="md:hidden ">
                            <Button 
                                type="primary" 
                                className="flex items-center"
                                icon={<svg className="h-4 w-4 mr-1 fill-current" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z" clip-rule="evenodd"></path></svg>}
                                onClick={showFilter}
                                >
                                Filter
                            </Button>
                        </div>
                    </div>
                    
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    <div>
                        <TractorCardSmall imageUrl={tractor1} />
                    </div>
                    <div>
                        <TractorCardSmall imageUrl={tractor2} />
                    </div>
                    <div>
                        <TractorCardSmall imageUrl={tractor3} />
                    </div>
                    <div>
                        <TractorCardSmall imageUrl={tractor2} />
                    </div>
                    <div>
                        <TractorCardSmall imageUrl={tractor1} />
                    </div>
                    <div>
                        <TractorCardSmall imageUrl={tractor2} />
                    </div>
                    <div>
                        <TractorCardSmall imageUrl={tractor3} />
                    </div>
                    <div>
                        <TractorCardSmall imageUrl={tractor2} />
                    </div>
                    <div>
                        <TractorCardSmall imageUrl={tractor1} />
                    </div>
                    <div>
                        <TractorCardSmall imageUrl={tractor2} />
                    </div>
                    <div>
                        <TractorCardSmall imageUrl={tractor3} />
                    </div>
                    <div>
                        <TractorCardSmall imageUrl={tractor1} />
                    </div>

                </div>
                
                <div>
                    <Drawer
                        placement="right"
                        // width="auto"
                        closable={false}
                        onClose={onFilterClose}
                        visible={openFilter}
                        bodyStyle={{padding:0}}
                        width={320}
                        footer={<Button className="flex justify-center w-24" type="dashed" onClick={onFilterClose}>Close</Button>}
                        footerStyle={{display: "flex", justifyContent: "center"}}
                    >
                        <TractorFilter />
                    </Drawer>
                </div>



            </div>

    );
}

export default TractorListings;
